export const AUTH_SUPPLIER_ZF_REPORT_REVIEW = 'supplier:zfReport:review'
export const AUTH_SUPPLIER_ZF_REPORT_SUBMIT = 'isSupplier:zfReport:submit'
export const AUTH_SUPPLIER_ZF_REPORT_CONFIRM = 'supplier:zfReport:confirm'
export const AUTH_SUPPLIER_ZF_REPORT_UPDATE = 'supplier:zfReport:update'
export const AUTH_SUPPLIER_ZF_REPORT_UPLOAD_IMAGE = 'isSupplier:zfReport:upload:image'
export const AUTH_SUPPLIER_ZF_REPORT_UPLOAD_PDF = 'supplier:zfReport:upload:pdf'
// 导入直发计划
export const AUTH_SUPPLIER_ZF_REPORT_UPLOAD_PLAN = 'supplier:zfReport:upload:plan'

// 项目开发进度看板
export const AUTH_PRODUCT_MANAGEMENT_ADD = 'product:management:add'
export const AUTH_PRODUCT_MANAGEMENT_BOSS = 'product:management:boss'
export const AUTH_PRODUCT_MANAGEMENT_BU = 'product:management:bu'
export const AUTH_PRODUCT_MANAGEMENT_PRODUCT = 'product:management:product'
export const AUTH_PRODUCT_MANAGEMENT_QC = 'product:management:qc'
export const AUTH_KNOWLEDGE_DEPT_EDIT = 'knowledge-dept-edit'
export const AUTH_KNOWLEDGE_ALL_DEPT_EDIT = 'knowledge-all-file-edit'
export const AUTH_KNOWLEDGE_COMPANY_EDIT = 'knowledge-company-edit'
export const AUTH_KNOWLEDGE_DEPT_FILE = 'knowledge-dept-file'

export const NUMBER_INPUT_PRECISION_INT = 0

export const CRYPTO_SECRET_KEY = 'nest-rpa'

export const AUTH_RPA_STORE_PAYMENT_TASK_TYPE = 'tools:rpa:store-payment-task-type'

export const AUTH_RPA_STORE_DATE_RANGE_TASK_TYPE = 'tools:rpa:store-date-range-task-type'
export const AUTH_RPA_SHIPMENT_TASK_TYPE = 'tools:rpa:store-shipment-task-type'
export const NUMBER_MEAN_MAX = 99999999

// 经营看板
export const AUTH_COCKPIT_VIEW = 'view:oa:cockpit'

export const LOGISTIC_FEE_TYPE = [
  { type: 1, name: '运输费' },
  { type: 2, name: '报关费' },
  { type: 3, name: '税金' },
  { type: 4, name: '商检费' },
  { type: 5, name: '买单费' },
  { type: 6, name: '拆托费' },
  { type: 7, name: '其他' },
]
export const LOGISTIC_FEE_TYPE_MAP = LOGISTIC_FEE_TYPE.reduce((pre, next) => Object.assign(pre, { [next.type]: next.name }), {})

export const LOGISTIC_ROUTE_TYPE = ['生成头程总单', '已装柜', '预计开船时间', '甩柜/延船（新单禁用）', '启运港海关查验', '启运港报关放行', '甩柜/延船.', '已开船']

export const REGION_HOST = {
  us: 'https://www.amazon.com',
  de: 'https://www.amazon.de',
  fr: 'https://www.amazon.fr',
  uk: 'https://www.amazon.co.uk',
  es: 'https://www.amazon.es',
  it: 'https://www.amazon.it',
  ca: 'https://www.amazon.ca',
  jp: 'https://www.amazon.co.jp',
  mx: 'https://www.amazon.com',
}

export const CM_TO_INCH = 0.3937
export const KG_TO_LBS = 2.2046
export const PRODUCT_STANDARD_UNIT_LIST = ['PCS', '套', '件', '个']
export const PRODUCT_COLOR_LIST = ['红', '黄', '蓝', '绿', '黑', '紫', '橙', '褐', '透明']
export const PRODUCT_RESOURCE_LIST = ['新项目新品', '老项目新品']
export const PRODUCT_UPDATE_LIST = ['产品变更', '包装变更']
export const PRODUCT_SALE_STATUS_LIST = ['保留', '非保留']
export const HTTP_OK = '200'
export const PREVIEW_PREFIX = 'https://view.officeapps.live.com/op/view.aspx'
// export const OSS_URL = 'https://online-hhxc.oss-cn-shenzhen.aliyuncs.com/'
export const OSS_URL = 'https://hhxc-oss.oss-cn-shenzhen.aliyuncs.com/'

export const DEPT_CONFIG = new Map([
  [
    '烧烤/取暖事业部',
    {
      color: '#2075FF',
      icon: 'https://online-hhxc.oss-cn-shenzhen.aliyuncs.com/uploads/1746632401189_烧烤.png',
    },
  ],
  [
    '过滤事业部',
    {
      color: '#FF7349',
      icon: 'https://online-hhxc.oss-cn-shenzhen.aliyuncs.com/uploads/1746632419788_过滤.png',
    },
  ],
  [
    '五金事业部',
    {
      color: '#A356F1',
      icon: 'https://online-hhxc.oss-cn-shenzhen.aliyuncs.com/uploads/1746632439988_五金.png',
    },
  ],
  [
    '庭院事业部',
    {
      color: '#FFC130',
      icon: 'https://online-hhxc.oss-cn-shenzhen.aliyuncs.com/uploads/1746632459554_庭院.png',
    },
  ],
  ['浴室事业部', { color: '#0DCD7F', icon: 'https://online-hhxc.oss-cn-shenzhen.aliyuncs.com/uploads/1746632478569_浴室.png' }],
  ['渠道创新中心', { color: '#0BC6CA', icon: 'https://online-hhxc.oss-cn-shenzhen.aliyuncs.com/uploads/1746632496667_创新中心.png' }],
  ['未完成部分', { color: '#e4e8f1', icon: 'https://online-hhxc.oss-cn-shenzhen.aliyuncs.com/uploads/1746632496667_创新中心.png' }],
])

export const OA_PROJECT_NAME = 'OA_PROJECT_TYPE'
